//
//
//
//
//
//
//
//
//

import { getPlatformIcon } from '@/lib/platforms'

export default {
  name: 'PlatformIcon',
  props: {
    platform: {
      type: String,
      required: true
    },
    colored: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    platformIcon() {
      if (!this.platform) {
        return ''
      }
      return getPlatformIcon(this.platform)
    },
    platformColor() {
      return `is-${this.platform.toLowerCase()}`
    }
  }
}
